import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Entity } from '../../objects/entity';

import { WorkflowService } from '../../service/workflow.service';

import { FormsModule } from '@angular/forms';

import { AgGridModule } from 'ag-grid-angular';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';

// BUGBUG:  ANGULAR 20 UPDATE
// import { Dropdown } from 'primeng/dropdown';
// import { AutoCompleteModule } from 'primeng/autocomplete';


@Component({
    selector: 'app-entity-workflow-management',
    templateUrl: './entity-workflow-management.component.html',
    styleUrls: ['./entity-workflow-management.component.css'],
    standalone: true,
    imports: [
      AgGridModule,
      FormsModule,
      MatInputModule,
      MatGridListModule,
    ]
  })
export class EntityWorkflowManagementComponent extends Entity implements OnInit {

  workflowSetup = {
                    contractType: null,
                    transactionType: null,
                    documentType: null,
                    amountThreshold: null  
                  };

  transactionTypeList: any;
  documentTypesList: any;
  thresholdList: any;

  constructor(
              
              private workflowService: WorkflowService,
              
              private dialogRef: MatDialogRef<EntityWorkflowManagementComponent>) { 

    super();

  }
  // constructor(private dialogRef: MatDialogRef<EntityWorkflowManagementComponent>) { }

  async ngOnInit() {

    // this.contractTypes = contractTypesResponse.values[0];

    // this.transactionTypeList = await this.workflowService.getStaticSheetWorkflowColumn('transactionType');
    // this.documentTypesList = await this.workflowService.getStaticSheetWorkflowColumn('documentType');
    // this.thresholdList = await this.workflowService.getStaticSheetWorkflowColumn('valueThreshold');
  }


  async onSubmit() {

    this.dialogRef.close(this.workflowSetup);

  }

  cancelSubmit() {
    this.dialogRef.close(null);
  }

}
